import styled from "styled-components";

export const SearchBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.75rem 1rem;
  width: 100%;
  margin: 1rem 0 0.5rem;
  padding: 1rem 1.1rem;
  border-radius: 14px;
  border: 1px solid color-mix(in srgb, var(--info) 18%, transparent);
  background: var(--surface-glass);
`;

export const SearchField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  min-width: min(100%, 260px);
  flex: 1 1 220px;

  label {
    font-size: 0.82rem;
    font-weight: 600;
    color: var(--text-heading);
    letter-spacing: 0.02em;
  }
`;

export const SearchInput = styled.input`
  width: 100%;
  max-width: 220px;
  padding: 0.65rem 0.85rem;
  border-radius: 10px;
  border: 1px solid var(--border-subtle);
  background: var(--surface-overlay);
  color: var(--text-primary);
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;

  &::placeholder {
    color: var(--input-placeholder);
    font-weight: 500;
    letter-spacing: normal;
    text-transform: none;
  }

  &:focus {
    outline: none;
    border-color: var(--info);
    box-shadow: 0 0 0 2px color-mix(in srgb, var(--info) 18%, transparent);
  }

  &:disabled {
    opacity: 0.7;
    cursor: wait;
  }
`;

export const SearchHint = styled.span`
  font-size: 0.78rem;
  color: var(--text-muted);
`;

export const SearchButton = styled.button`
  padding: 0.68rem 1.15rem;
  border: none;
  border-radius: 10px;
  background: ${props => {
    if (props.$active) {
      return 'var(--surface-1)';
    }
    return 'var(--brand-lime)';
  }};
  
  color: ${props => {
    if (props.$active) {
      return 'var(--text-secondary)';
    }
    return 'var(--text-on-lime)';
  }};

  font-size: 0.92rem;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.15s ease, opacity 0.15s ease;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.72;
    cursor: wait;
  }
`;

export const SearchError = styled.p`
  flex: 1 1 100%;
  margin: 0;
  color: var(--danger);
  font-size: 0.88rem;
  line-height: 1.4;
`;
